import React, {useEffect, useState} from 'react';
import {Alert, Button, Checkbox, Form, InputNumber, message, Select} from "antd";
import {WarningOutlined} from "@ant-design/icons";

// 兜底域名选项（当远程获取失败时使用）
const fallbackHostOptions = [
  { value: 'edgeone.51shazhu.com', label: 'edgeone.51shazhu.com（不推荐)' },
  { value: 'dl.z.wiki', label: 'dl.z.wiki (不推荐)' },
  { value: 'tc.z.wiki', label: 'tc.z.wiki (不推荐)' },
  { value: 'y.z.wiki', label: 'y.z.wiki (阿里云节点,不推荐)' },
  { value: 'tc-new.z.wiki', label: 'tc-new.z.wiki (国内域名)' },
  { value: 'img.51shazhu.com', label: 'img.51shazhu.com（国内域名）' },
  { value: 'a.tuchuangyun.top', label: 'a.tuchuangyun.top (国外节点)' },
  { value: 'jp.tuchuangyun.top', label: 'jp.tuchuangyun.top (仅国外可访问，国内无法访问)' },
  { value: 'xland.eu.org', label: 'xland.eu.org (国外很快，国内速度一般)' },
];

// 远程域名配置地址
const REMOTE_DOMAINS_URL = 'https://tc-new.z.wiki/autoupload/fdd/config/domains.json';

const Config: React.FC = () => {
  const [config, setConfig] = useState<Record<string, string>>({});
  const [bigFileUpload, setBigFileUpload] = useState(false);
  const [isActiveVip, setIsActiveVip] = useState(false);
  const [lifecycleDays, setLifecycleDays] = useState<number | null>(null);
  const [hostOptions, setHostOptions] = useState<Array<{value: string, label: string}>>([]);
  const [defaultDomains, setDefaultDomains] = useState<Array<{value: string, label: string}>>(fallbackHostOptions);

  // 获取远程默认域名配置
  useEffect(() => {
    // 添加时间戳参数防止缓存
    const urlWithTimestamp = `${REMOTE_DOMAINS_URL}?t=${Date.now()}`;
    
    fetch(urlWithTimestamp, {
      method: 'GET',
      mode: 'cors', // 支持跨域
    })
      .then(res => res.json())
      .then((remoteDomains) => {
        console.info('成功获取远程域名配置', remoteDomains);
        if (Array.isArray(remoteDomains) && remoteDomains.length > 0) {
          setDefaultDomains(remoteDomains);
        } else {
          console.warn('远程域名配置格式不正确，使用兜底数据');
        }
      })
      .catch((error) => {
        console.error('获取远程域名配置失败，使用兜底数据', error);
        // 保持使用兜底数据
      });
  }, []);

  useEffect(() => {
    fetch('/login/info', {
      method: 'GET',
    }).then(res => res.json()).then((e) => {
      console.info(e)
      if (e.isSuccess) {
        const configData = JSON.parse(e.detail?.config || '{}');
        setConfig(configData);
        setIsActiveVip(e.detail?.isActiveVip || false);
        setLifecycleDays(configData.lifecycleDays ? parseInt(configData.lifecycleDays) : null);
        
        // 处理域名列表：合并默认域名和用户配置域名
        const userDomains = e.detail?.domains || [];
        const userDomainOptions = userDomains.map((domain: string) => ({
          value: domain,
          label: domain
        }));
        
        // 合并默认域名和用户配置域名，去重
        const allOptions = [...defaultDomains, ...userDomainOptions];
        setHostOptions(allOptions);
      }
    })
  }, [defaultDomains])

  const [saving, setSaving] = useState(false)

  const handleSave = () => {
    console.info('handleSave', config)
    setSaving(true);
    
    // 更新配置对象包含生命周期天数
    const updatedConfig = {
      ...config,
      lifecycleDays: lifecycleDays?.toString() || ''
    };
    
    fetch('/admin/config/update', {
      method: 'POST',
      body: JSON.stringify(updatedConfig),
      headers: {
        'Content-Type': 'application/json;charset=utf8'
      }
    }).then(res => res.json()).then((data) => {
      console.info('flag is', data);
      if (data.success) {
        message.info('配置已更新')
      } else {
        message.error("配置更新失败")
      }
    }).finally(() => {
      setSaving(false);
    })
  }

  return (
    <>
      <Form>
        <Alert message="仅支持VIP用户" icon={<WarningOutlined/>} type="error" style={{marginBottom: '8px'}} showIcon/>
        {/* <Form.Item label="水印内容">
          <Input placeholder="请输入水印内容，最多20个字符串" value={config.watermask}
                 onChange={(e) => setConfig({...config, watermask: e.target.value.slice(0, 20)})}/>
        </Form.Item> */}
        {
          isActiveVip && (
            <Form.Item label="域名选择">
              <Select
                placeholder="请选择域名"
                value={config.host}
                onChange={(value) => setConfig({...config, host: value})}
                options={hostOptions}
                style={{ width: '100%' }}
              />
            </Form.Item>
          )
        }
        
        {
          isActiveVip && (
            <Form.Item label="生命周期设置">
              <InputNumber
                placeholder="请输入天数"
                min={1}
                max={99999999999}
                value={lifecycleDays}
                onChange={(value) => setLifecycleDays(value)}
                addonAfter="天"
                style={{ width: '100%' }}
              />
              <div style={{ fontSize: '12px', color: '#ff4d4f', marginTop: '4px' }}>
                ⚠️ 请谨慎设置生命周期，到期后图片将会被强行删除且无法恢复
              </div>
            </Form.Item>
          )
        }
        {
          config.allowJsUpload && <Form.Item label="特大文件上传">
            <Checkbox
              checked={bigFileUpload}
              onChange={(e) => {
                console.info('e', e.target.checked, config)
                setBigFileUpload(e.target.checked);
                (window as any)._debug_ = e.target.checked;
              }}
            >开启</Checkbox>
          </Form.Item>
        }

        <Form.Item>
          <Button type="primary" loading={saving} onClick={handleSave}>保存</Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default Config;